/**
 * navSource
 *
 * Which page the user clicked FROM on the rail, for the one navigation that
 * follows. Comp reads it to stay quiet when the user arrives from a page it
 * shares a selection with (Blended Roles, JD·Skills).
 *
 * Module-level and consume-once ON PURPOSE. The first version of this used
 * react-router's navigate(..., { state }) instead, which looked equivalent
 * and was not: the browser PERSISTS history state across a reload, so
 * refreshing /comp still saw `from: "/jd-skills"` from the previous visit
 * and silently skipped the popup on what was really a fresh arrival
 * (verified live - window.history.state still held it after F5). A module
 * variable is empty on every page load, which is exactly the intended
 * lifetime. Same reasoning as sharedSelection.js.
 */

let navFrom = null;

export function setNavFrom(path) {
  navFrom = path;
}

/**
 * Read WITHOUT clearing. It was consume-once at first, which broke under
 * StrictMode: App mounts twice, the first mount consumed the value and the
 * second saw null, so the popup appeared anyway on Blended Roles -> Comp
 * (verified live). Every navigation overwrites it - including a gateway
 * tile - so it can never describe anything but the trip just taken, and a
 * page load starts it at null.
 */
export function getNavFrom() {
  return navFrom;
}
